var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.8124,
    cy: 75.9376,
    r: 47.0089,
    fill: "#FFE7E7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.7499,
    cy: 44.1964,
    r: 2.94643,
    fill: "#FFE7E7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.955,
    cy: 32.5448,
    r: 5.49107,
    fill: "#FFE7E7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.6876,
    cy: 106.206,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.17,
    cy: 101.116,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.991,
    cy: 107.009,
    r: 2.54464,
    fill: "#FFE7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.3192 30.9476C85.1639 30.9145 85.1639 30.6929 85.3192 30.6599L87.6672 30.1606C87.7238 30.1485 87.7681 30.1044 87.7803 30.0479L88.2859 27.7165C88.3194 27.562 88.5398 27.562 88.5733 27.7165L89.0789 30.0479C89.0911 30.1044 89.1354 30.1485 89.192 30.1606L91.5399 30.6599C91.6952 30.6929 91.6952 30.9145 91.5399 30.9476L89.192 31.4469C89.1354 31.4589 89.0911 31.503 89.0789 31.5595L88.5733 33.8909C88.5398 34.0455 88.3194 34.0455 88.2859 33.8909L87.7803 31.5595C87.7681 31.503 87.7238 31.4589 87.6672 31.4469L85.3192 30.9476Z",
    fill: "#F8AFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4883 82.9343C21.5482 82.6511 21.9524 82.6511 22.0124 82.9343L22.9078 87.1645C22.9296 87.2676 23.0098 87.3483 23.1128 87.3707L27.2993 88.2827C27.5804 88.344 27.5804 88.7449 27.2993 88.8062L23.1128 89.7182C23.0098 89.7406 22.9296 89.8213 22.9078 89.9244L22.0124 94.1546C21.9524 94.4378 21.5482 94.4378 21.4883 94.1546L20.5929 89.9244C20.5711 89.8213 20.4908 89.7406 20.3878 89.7182L16.2014 88.8062C15.9203 88.7449 15.9203 88.344 16.2014 88.2827L20.3878 87.3707C20.4908 87.3483 20.5711 87.2676 20.5929 87.1645L21.4883 82.9343Z",
    fill: "#F8AFAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.825 45.4343C119.885 45.1511 120.289 45.1511 120.349 45.4343L120.871 47.9021C120.893 48.0052 120.973 48.0859 121.076 48.1083L123.525 48.6419C123.806 48.7032 123.806 49.1041 123.525 49.1653L121.076 49.6989C120.973 49.7214 120.893 49.8021 120.871 49.9052L120.349 52.3729C120.289 52.6561 119.885 52.6561 119.825 52.373L119.302 49.9052C119.28 49.8021 119.2 49.7214 119.097 49.6989L116.648 49.1653C116.367 49.1041 116.367 48.7032 116.648 48.6419L119.097 48.1083C119.2 48.0859 119.28 48.0052 119.302 47.9021L119.825 45.4343Z",
    fill: "#F8AFAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.623 84.999L131.443 88.8742L135.263 89.7064L131.443 90.5385L130.623 94.4137L129.802 90.5385L125.983 89.7064L129.802 88.8742L130.623 84.999Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3684 91.6792C55.6282 90.1719 52.5978 91.2455 55.6596 90.0928C57.9717 88.733 60.3585 87.4808 63.1802 86.8454C65.5772 86.3055 65.5187 86.3735 68.1435 86.5026C69.3969 86.8883 70.4342 87.7297 70.6284 88.7172C70.7888 89.5332 69.1449 90.7402 68.1435 91.1851C64.4008 92.8482 66.2255 91.9746 63.4902 92.7351C58.4103 94.1474 52.9433 96.5629 50.8091 100.32C49.6509 102.359 49.3702 104.729 50.3832 106.605C51.8015 109.231 56.1517 111.415 60.472 111.038C62.204 110.887 64.2218 110.558 65.8841 110.043C67.6416 109.499 68.7928 109.079 70.3099 108.234C73.8291 106.276 78.0233 103.732 81.4527 101.693",
    stroke: "#F8AFAF",
    strokeWidth: 1.01888,
    strokeLinecap: "round",
    strokeDasharray: "2.04 2.04"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.048 65.1383C118.294 51.5294 108.273 39.4868 94.6637 38.2403C81.0548 36.9938 69.0122 47.0155 67.7657 60.6244C67.486 63.6783 67.7738 66.6544 68.5428 69.4475C69.8109 75.6954 73.2755 82.1995 76.9547 87.7398C80.6419 93.2922 84.5699 97.9138 86.7934 100.393C87.9866 101.724 89.9635 101.894 91.375 100.805C94.2924 98.5542 99.7288 94.1104 104.807 88.6037C109.871 83.1129 114.632 76.51 116.13 69.9323C116.585 68.3962 116.896 66.7936 117.048 65.1383Z",
    fill: "url(#paint0_linear_293_9774)",
    stroke: "#F8AFAF",
    strokeWidth: 0.934463
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.082 63.7677C102.571 58.4243 98.6364 53.6958 93.293 53.2064C87.9496 52.717 83.2211 56.6519 82.7317 61.9953C82.2423 67.3387 86.1772 72.0672 91.5206 72.5566C96.864 73.046 101.592 69.1111 102.082 63.7677Z",
    fill: "white",
    stroke: "#F8AFAF",
    strokeWidth: 0.934463
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7187 71.8544L53.7193 71.8696L53.7208 71.8848C54.0003 74.5857 53.0341 77.7935 51.7422 80.6972C50.457 83.586 48.8811 86.1051 48.0157 87.4053C47.7838 87.7537 47.3414 87.8598 46.9807 87.6564C45.7519 86.9636 43.5497 85.6433 41.3219 83.9206C39.0871 82.1925 36.8624 80.0866 35.5524 77.8303L35.5442 77.8162L35.5351 77.8027C34.8808 76.8375 34.3862 75.7396 34.0983 74.537C32.8187 69.1932 36.1135 63.8239 41.4573 62.5444C46.8011 61.2649 52.1704 64.5596 53.4499 69.9034C53.6062 70.5563 53.6942 71.2091 53.7187 71.8544Z",
    fill: "#F8AFAF",
    stroke: "#F8AFAF",
    strokeWidth: 0.934463
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0874 71.1874C47.517 68.8051 45.1233 67.3363 42.741 67.9067C40.3588 68.4771 38.89 70.8708 39.4604 73.2531C40.0308 75.6354 42.4244 77.1042 44.8067 76.5338C47.189 75.9633 48.6578 73.5697 48.0874 71.1874Z",
    fill: "white",
    stroke: "#F8AFAF",
    strokeWidth: 0.934463
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_293_9774",
    x1: 94.6211,
    y1: 38.7056,
    x2: 88.8216,
    y2: 102.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAddress);
export default __webpack_public_path__ + "static/media/empty_address.a31eb0b7ac38d022d3bdc191762f4abe.svg";
export { ForwardRef as ReactComponent };